export default __webpack_public_path__ + "static/media/template_pro__0020_7---MikitaBadz.f8583ad7.png";